import { Container, Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import Plan from "./plan"

const Plans = ({ plans, selectedPlanId, onSelect, onSubmit }) => (
  <Container sx={{ backgroundColor: "lightBlue", py: 6 }}>
    <Heading
      sx={{
        mb: [4, 6],
        textAlign: "center",
        lineHeight: "body",
        variant: "vwo.heading",
      }}
    >
      <Trans i18nKey="ChoosePlan.Plans.title" />
    </Heading>

    <div
      sx={{
        display: [null, "grid"],
        gridTemplateColumns: [null, "repeat(3, 33%)"],
        justifyContent: "center",
        gap: [null, 4],
      }}
    >
      {plans.map((plan, index) => (
        <Plan
          key={index}
          plan={plan}
          selectedPlanId={selectedPlanId}
          onSelect={onSelect}
          onSubmit={onSubmit}
          sx={{
            order: [null, plan.group ? Math.ceil(plans.length / 2) : index],
          }}
        />
      ))}
    </div>
  </Container>
)

export default Plans
